import { createContext } from 'react';
export const LibContext = createContext();
export const MediaContext = createContext();